export default __webpack_public_path__ + "static/media/hacker.bdef2577.svg";